import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { URL } from "../../Redux/common/url";

function AboutCom2() {
  const [showView, setShowView] = useState(false);
  const [showViewdata, setShowViewdata] = useState("");
const get_home_all_pro = useSelector((state) =>
    state?.allapi?.get_home_all_pro ? state?.allapi?.get_home_all_pro : {}
  );
  // const handleCloseDelete = () => setShowDelete(false);
  const handleCloseView = () => setShowView(false);

  const handleView = (e) => {
    setShowView(true);
    setShowViewdata(e);
  };
  return (
    <div>
      <Modal show={showView} size="xl" onHide={handleCloseView}>
        <Modal.Header closeButton>
          {/* <Modal.Title> Details</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          <p style={{ fontSize: "11px" }}> {showViewdata}</p>
        </Modal.Body>
      </Modal>
      <div className="d-flex mt-5 vts" style={{ overflowX: "scroll" }}>

{ 
  get_home_all_pro?.ourValue && get_home_all_pro?.ourValue?.map((data,i) => {

    return (
      <div
          className="col-8 pt-3 pb-3"
          //   data-aos="fade-right"
          //   data-aos-delay={"0"}
        >
          <div className="px-3 ">
            <div className=" bestsellingdsvs">
              <div className="card mb-3 box" style={{ minHeight: "300px" }}>
                <div className="position-relative">
                  <img
                    className="pic card-img-top"
                    style={{ height: "200px" }}
                    src={URL?.API_BASE_URL + data?.image}
                    alt="..."
                  />
                  <div className="position-absolute    bstTile">
                    <h4 className="card-title text-center">{data?.name}</h4>
                  </div>
                </div>
                <div
                  className="card-body pb-3"
                  // style={{ borderBottom: "3px solid dodgerblue" }}
                >
                  {/* <h4 className="card-title text-center">Integrity</h4>
                  <br /> */}
                  <p className="card-text  card-textttt">
                   {data?.description}
                  </p>

                  <button
                    className="buyBtn "
                    onClick={() =>
                      handleView(
                        data?.description
                      )
                    }
                  >
                    Read More
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
    )
    
  })
}

        {/* <div
          className="col-8 pt-3 pb-3"
          //   data-aos="fade-right"
          //   data-aos-delay={"0"}
        >
          <div className="px-3 ">
            <div className=" bestsellingdsvs">
              <div className="card mb-3 box" style={{ minHeight: "300px" }}>
                <div className="position-relative">
                  <img
                    className="pic card-img-top"
                    style={{ height: "200px" }}
                    src="/assets/imgs/in.png"
                    alt="..."
                  />
                  <div className="position-absolute    bstTile">
                    <h4 className="card-title text-center">Integrity</h4>
                  </div>
                </div>
                <div
                  className="card-body pb-3"
                  // style={{ borderBottom: "3px solid dodgerblue" }}
                >
                  
                  <p className="card-text  card-textttt">
                    Our integrity in our work methodology has helped us create a
                    strong system where growth & prosperity of each member of
                    the RIL community is valued more than anything else.
                  </p>

                  <button
                    className="buyBtn "
                    onClick={() =>
                      handleView(
                        "Our integrity in our work methodology has helped us create a strong system where growth & prosperity of each member of the RIL community is valued more than anything else"
                      )
                    }
                  >
                    Read More
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-8 pt-3"
          //   data-aos="fade-right"
          //   data-aos-delay={"0"}
        >
          <div className="px-3 ">
            <div className=" bestsellingdsvs">
              <div className="card mb-3 box" style={{ minHeight: "300px" }}>
                <div className="position-relative">
                  <img
                    className="pic card-img-top"
                    style={{ height: "200px" }}
                    src="/assets/imgs/ll.png"
                    alt="..."
                  />
                  <div className="position-absolute    bstTile">
                    <h4 className="card-title text-center">Loyality</h4>
                  </div>
                </div>
                <div
                  className="card-body pb-3"
                  // style={{ borderBottom: "3px solid dodgerblue" }}
                >
                  <p className="card-text  card-textttt">
                    The loyality with which each Community member works here
                    leads to a commitment to focus on self growth and make
                    leaders personality on the whole community.
                  </p>
                  <button
                    className="buyBtn "
                    onClick={() =>
                      handleView(
                        "The loyality with which each Community member works here leads to a commitment to focus on self growth and make leaders personality on the whole community."
                      )
                    }
                  >
                    Read More
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-8 pt-3"
          //   data-aos="fade-right"
          //   data-aos-delay={"0"}
        >
          <div className="px-3 ">
            <div className=" bestsellingdsvs">
              <div className="card mb-3 box" style={{ minHeight: "300px" }}>
                <div className="position-relative">
                  <img
                    className="pic card-img-top"
                    style={{ height: "200px" }}
                    src="/assets/imgs/cc.png"
                    alt="..."
                  />
                  <div className="position-absolute    bstTile">
                    <h4 className="card-title text-center">
                      Customer Happiness
                    </h4>
                  </div>
                </div>
                <div
                  className="card-body pb-3"
                  // style={{ borderBottom: "3px solid dodgerblue" }}
                >
                  <p className="card-text  card-textttt">
                    Customer happiness is more important For us, so we worked on
                    our Services And Products to give best for our Customers.
                    Our customers are the backbone of our business, so we need
                    to do whatever it takes to ensure you're happy. We know, a
                    successful business is made up of happy customers.
                  </p>
                  <button
                    className="buyBtn "
                    onClick={() =>
                      handleView(
                        "Customer happiness is more important For us, so we worked on our Services And Products to give best for our Customers. Our customers are the backbone of our business, so we need to do whatever it takes to ensure you're happy. We know, a successful business is made up of happy customers."
                      )
                    }
                  >
                    Read More
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-8 pt-3"
          //   data-aos="fade-right"
          //   data-aos-delay={"0"}
        >
          <div className="px-3 ">
            <div className=" bestsellingdsvs">
              <div className="card mb-3 box" style={{ minHeight: "300px" }}>
                <div className="position-relative">
                  <img
                    className="pic card-img-top"
                    style={{ height: "200px" }}
                    src="/Transparency-4.png"
                    alt="..."
                  />
                  <div className="position-absolute    bstTile">
                    <h4 className="card-title text-center">Transparency</h4>
                  </div>
                </div>
                <div
                  className="card-body pb-3"
                  // style={{ borderBottom: "3px solid dodgerblue" }}
                >
                  <p className="card-text  card-textttt">
                    Customers can expect transparency from RIL INDIA they're
                    doing business with.Our all services for our Customers so
                    everything is transparent for you and customers deserve
                    openness from the RIL INDIA because you're part of our
                    Community.
                  </p>
                  <button
                    className="buyBtn "
                    onClick={() =>
                      handleView(
                        "Customers can expect transparency from RIL INDIA they're doing business with.Our all services for our Customers so everything is transparent for you and customers deserve openness from the RIL INDIA because you're part of our Community."
                      )
                    }
                  >
                    Read More
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* <div
          className="col-lg-6 pt-3"
          data-aos="fade-right"
          data-aos-delay={"100"}
        >
          <div className="card box1 mb-3" style={{ minHeight: "380px" }}>
            <img
              className="pic card-img-top"
              style={{ height: "200px" }}
              src="/assets/imgs/ll.png"
              alt="..."
            />
            <div
              className="card-body"
              // style={{ borderBottom: "3px solid  #006633" }}
            >
              <h4 className="card-title text-center">Loyality</h4>

              <p className="card-text text-center pb-5 pt-3 my-3">
                The loyality with which each Community member works here leads
                to a commitment to focus on self growth and make leaders
                personality on the whole community.
              </p>
            </div>
          </div>
        </div> */}
      </div>
  
    </div>
  );
}

export default AboutCom2;
